import React from 'react';
import DropdownBS from '../../DropdownBS';

function SelectCountry(props){
  return(
    <DropdownBS className={props.className} onChange={props.onChange} options={props.countries} value={props.value} closeOnSelect={true} />
  )
}

export default SelectCountry;